<template>
    <div>
        <div
            v-for="week in weeks"
            :key="week.label + week.range"
            v-if="showDisabled || !week.disabled"
            class="ppv2-flex ppv2-items-center ppv2-gap-4 ppv2-px-4 ppv2-py-3 ppv2-border-t last:ppv2-border-b-0 ppv2-border-black ppv2-border-opacity-[8%]"
            :class="week.disabled ? 'ppv2-opacity-40 ppv2-cursor-not-allowed ppv2-select-none' : ''"
        >
            <BaseCheckbox
                :value="selected.some((w) => w.label === week.label)"
                :disabled="week.disabled"
                @input="!week.disabled && toggleWeek(week)"
                size="md"
                has-border-checked
            />

            <div class="ppv2-flex ppv2-items-center ppv2-gap-8 ppv2-flex-1">
                <div
                    class="ppv2-bg-white dark:ppv2-bg-dark-popup ppv2-border ppv2-border-gray-100 ppv2-rounded-full ppv2-px-3 ppv2-py-1 ppv2-text-xs poppinsBold ppv2-text-black"
                >
                    {{ week.label }}
                </div>

                <div class="ppv2-text-sm ppv2-text-black poppinsRegular">
                    {{ week.range }}
                </div>
            </div>

            <span
                v-if="week.disabled"
                class="ppv2-text-[11px] poppinsMedium ppv2-text-gray-400 ppv2-bg-gray-100 ppv2-px-2 ppv2-py-0.5 ppv2-rounded-full ppv2-ml-auto ppv2-whitespace-nowrap poppinsMedium"
            >
                Non publiée
            </span>
        </div>
    </div>
</template>

<script>
import BaseCheckbox from '../../../Shared/BaseCheckbox.vue'

export default {
    components: {
        BaseCheckbox,
    },
    props: {
        title: String,
        weeks: {
            type: Array,
            default: () => [],
        },
        selected: {
            type: Array,
            default: () => [],
        },
        showDisabled: {
            type: Boolean,
            default: true,
        },
    },
    watch: {
        weeks: {
            immediate: true,
            handler(weeks) {
                const enabledWeeks = weeks.filter((w) => !w.disabled)

                this.$emit('update:selected', enabledWeeks)
            },
        },
    },
    methods: {
        toggleWeek(week) {
            if (week.disabled) return
            let values = [...(this.selected || [])]

            const exists = values.find((w) => w.label === week.label)

            if (exists) {
                values = values.filter((w) => w.label !== week.label)
            } else {
                values.push(week)
            }

            this.$emit('update:selected', values)
        },
    },
}
</script>
